import script from "./ProblemList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemList.vue?vue&type=script&setup=true&lang=js"

import "./ProblemList.vue?vue&type=style&index=0&id=02b5c49c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b5c49c"]])

export default __exports__